import useSWR from 'swr';
import config from '../config';

function useAuth() {
    const { data, error, isLoading } = useSWR('authData', () => fetch(`${config.apiUrl}/company`).then(res => res.json()));
    
    return {
      data,
      isLoading,
      isError: error,
    }
}

export default useAuth;
